import {
  BildResursData,
  DokumentCommonResursData,
  GranskningResursIndex,
  RitningResursData,
  SearchIndexResult
} from 'models';

import { DokumentationstypEnum, GenreFormStriktEnum } from 'enums';

import { isGranskningBildMetadata, isGranskningRitningMetadata } from './typeGuards';

const toCommonResursData = (resurs: GranskningResursIndex): DokumentCommonResursData => ({
  resursId: resurs.resurs_id,
  licensnamn: resurs.resurs_metadata.licens_namn,
  licensUri: undefined,
  tillkomstdatum: resurs.resurs_metadata.tillkomstdatum,
  thumbnailUrl: resurs.thumbnail_url,
  url: `${process.env.PUBLIC_URL}/api/bebyggelseobjekt/utkast/${resurs.utkast_id}/dokumentation/${resurs.resurs_id}/original.${resurs.file_extension}`,
  titel: resurs.resurs_metadata.titel,
  vinjett: resurs.vinjett,
  utkastId: resurs.utkast_id
});

// Mappa sökresultat från avancerad arkivsökning till BildResursData
export const toResursDataFromSearchIndexResult = (searchIndexResult: SearchIndexResult, vinjettUri?: string) => {
  const commonResurs = {
    licensUri: searchIndexResult.licens,
    tillkomstdatum: searchIndexResult.tillkomstdatumStart,
    thumbnailUrl: `${searchIndexResult.uri}/presentation/miniatyr`,
    titel: searchIndexResult.titel,
    vinjett: searchIndexResult.uri === vinjettUri,
    uri: searchIndexResult.uri,
    vy: searchIndexResult.orientering,
    dokumentationstyp: searchIndexResult.genreFormStrikt
  } as DokumentCommonResursData;

  if (searchIndexResult.genreFormStrikt === GenreFormStriktEnum.FOTOGRAFI) {
    return {
      ...commonResurs,
      bildtext: '',
      upphovsman: '',
      dokumentationstyp: DokumentationstypEnum.BILD
    } as BildResursData;
  }

  if (searchIndexResult.genreFormStrikt === GenreFormStriktEnum.RITNING) {
    return {
      ...commonResurs,
      motivbeskrivning: '',
      dokumentationstyp: DokumentationstypEnum.RITNING
    } as RitningResursData;
  }

  throw new Error('Fick oväntad dokumenttyp ' + searchIndexResult.genreFormStrikt);
};

export const toMellanlagerResurs = (resurs: GranskningResursIndex): BildResursData | RitningResursData => {
  if (resurs.dokumentationstyp === DokumentationstypEnum.BILD && isGranskningBildMetadata(resurs.resurs_metadata)) {
    return {
      ...toCommonResursData(resurs),
      upphovsman: `${resurs.resurs_metadata.upphovsman_fornamn} ${resurs.resurs_metadata.upphovsman_efternamn}`,
      vy: resurs.resurs_metadata.vy,
      bildtext: resurs.resurs_metadata.bildtext,
      dokumentationstyp: resurs.dokumentationstyp
    } as BildResursData;
  } else if (
    resurs.dokumentationstyp === DokumentationstypEnum.RITNING &&
    isGranskningRitningMetadata(resurs.resurs_metadata)
  ) {
    return {
      ...toCommonResursData(resurs),
      vy: resurs.resurs_metadata.vy,
      motivbeskrivning: resurs.resurs_metadata.motivbeskrivning,
      dokumentationstyp: resurs.dokumentationstyp
    } as RitningResursData;
  }

  throw new Error('Kunde inte avgöra typ av mellanlagerresurs');
};
